<svelte:options
  customElement={{ tag: "hc-select-chip", shadow: "none", props: { selectedValue: { attribute: "selected-value" } } }}
/>

<script lang="ts">
  import tracker from "../tracking/Tracker";
  import { untrack } from "svelte";
  import { isActive } from "../toggle/Toggle";

  interface Props {
    values: string;
    selectedValue?: string;
  }

  const { values, selectedValue }: Props = $props();

  const parsedValues = $derived(JSON.parse(values));
  /*                                                                */
  /*                                                                                      */
  let currentValue = $derived(
    isActive("HEUREKA_2387_FIX_WRONG_SELECTED_SORTING_OPTION")
      ? (selectedValue ?? parsedValues?.find((v) => v?.isDefault)?.value)
      : untrack(() => selectedValue ?? parsedValues?.find((v) => v?.isDefault)?.value),
  );
  let currentName = $derived(parsedValues?.find((v) => v?.value === currentValue)?.displayName);
  let isOpen = false;

  function onmousedown() {
    if (!isOpen) {
      isOpen = true;
      tracker.submitEvent({ san_Foldout: "sorting_open" });
    }
  }
  function onchange() {
    isOpen = false;
  }
  function onblur() {
    isOpen = false;
  }
</script>

<div style="position: relative">
  <oc-chip-v2 class="heureka_sorting__dropdown">
    <label class="heureka_sorting__label" for="heureka_desktopSorting--select">Sortieren nach: </label>
    {currentName}
    <oc-icon-v1 type="arrow-down" size="50"></oc-icon-v1>
  </oc-chip-v2>
  <select
    id="heureka_desktopSorting--select"
    name="sortiertnach"
    required={true}
    bind:value={currentValue}
    class="heureka_sorting__select heureka_sorting__select--harmonized"
    {onmousedown}
    {onchange}
    {onblur}
  >
    {#each parsedValues as value (value)}
      <option selected={value["isDefault"]} value={value["value"]}>{value["displayName"]}</option>
    {/each}
  </select>
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .heureka_sorting {
    margin: 0 8px 12px 16px;

    .mo-frame & {
      margin: 0 0 0 tokens.$oc-semantic-spacing-100;
    }

    &__dropdown {
      position: relative;
      white-space: nowrap;
    }

    &__select {
      cursor: pointer;
    }

    &__select--harmonized {
      width: fit-content;
      background-color: tokens.$oc-base-color-gray-25;
      border: 0;
      font: tokens.$oc-semantic-color-text-secondary;

      /*                             */
      &:focus-visible {
        outline: none;
      }

      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }

    &__label {
      color: tokens.$oc-semantic-color-text-secondary;
      font: tokens.$oc-semantic-font-copy-75;
    }
  }
</style>
